import { useMutation } from '@tanstack/react-query';
import { doSearchRequest } from '../queries';
import { searchStore } from '../stores/searchStore';

export function useDoSearch() {
  const setResult = searchStore.getState().setSearchResult;

  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['doSearch'], 
    mutationFn: (search: string) => doSearchRequest(search),
    onSuccess: (data) => {
      setResult(data);
    },
    retry: false
  });

  return { mutate, isPending, isError };
}